import { defineComponent } from 'vue-demi';
import { s as script$1 } from './ServiceNavigationMenu-4efbe94f.js';
import { resolveComponent, openBlock, createElementBlock, renderSlot, createBlock, createCommentVNode } from 'vue';

var script = defineComponent({
  components: {
    ServiceNavigationMenu: script$1
  },
  props: {
    menuItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showMenu() {
      return this.menuItems.length > 0;
    }
  }
});

const _hoisted_1 = {
  class: "grow overflow-hidden",
  "data-test": "service-navigation-content"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_service_navigation_menu = resolveComponent("service-navigation-menu");
  return openBlock(), createElementBlock("div", _hoisted_1, [renderSlot(_ctx.$slots, "default", {}, () => [_ctx.showMenu ? (openBlock(), createBlock(_component_service_navigation_menu, {
    key: 0,
    items: _ctx.menuItems
  }, null, 8 /* PROPS */, ["items"])) : createCommentVNode("v-if", true)])]);
}

script.render = render;
script.__file = "src/components/ServiceNavigationContent/ServiceNavigationContent.vue";

export { script as s };
